


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'
import { AttachmentAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { CreateAttachmentModel } from '@/components/form/CreateAttachmentForm.vue'
import { escapeHtml } from '@/helpers/html'

@Component
export default class Files extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    modalCreateAttachment: boolean = false
    submittingCreateAttachment: boolean = false
    formCreateAttachment: CreateAttachmentModel = { file: null }
    fileError: boolean = false

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    async doCreateAttachment(closeModal: () => void): Promise<void> {
        this.submittingCreateAttachment = true

        try {
            const attachmentId = uuid()

            await AttachmentAPI.createWithFile(
                this.referral,
                attachmentId,
                this.formCreateAttachment.file,
            )

            const attachment = await AttachmentAPI.get(attachmentId)
            this.referral.attachments.push(attachment)

            this.$emit('reload')
            closeModal()

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.submittingCreateAttachment = false
        }
    }
    @Watch('modalCreateAttachment')
    resetCreateAttachment(): void {
        this.formCreateAttachment = { file: null }
    }

    getAttachmentIcon(attachmentName: string) {
        if (attachmentName.endsWith('pdf')) {
            return 'icon-file-pdf'
        } else if (attachmentName.endsWith('jpg') || attachmentName.endsWith('png') || attachmentName.endsWith('jpeg')) {
            return 'icon-file-image'
        } else if (attachmentName.endsWith('csv')) {
            return 'icon-file-csv'
        } else if (attachmentName.endsWith('pptx') || attachmentName.endsWith('ppt')) {
            return 'icon-file-powerpoint'
        } else if (attachmentName.endsWith('txt')) {
            return 'icon-file-text'
        } else if (attachmentName.endsWith('xlsx') || attachmentName.endsWith('xlsm') || attachmentName.endsWith('xls')) {
            return 'icon-file-excel'
        } else if (attachmentName.endsWith('doc') || attachmentName.endsWith('docm') || attachmentName.endsWith('docx')) {
            return 'icon-file-word'
        } else {
            return 'icon-file'
        }
    }
}
